import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import ImageButton from '../../molecules/ImageButton/ImageButton'
import RadioButton from '../../atoms/RadioButton/RadioButton'
import './EditorLimitTextField.css'

const EditorLimitTextField = ({
  index,
  limitLength,
  text,
  answerChoiceId,
  onChangeText,
  onChangeImage,
  onClickImage,
  onChangeAnswerChoice,
  showLimitCount,
  showImage,
  showRadioButton,
  choiceImage,
  placeholder,
  type
}) => {
  const handleChangeImage = e => {
    const file = e.target.files[index]
    // 画像を選択し、アップロード後にもう一度画像選択画面を表示し、キャンセルボタンを押すとfileがundefinedになるため、その場合は何もしない
    if (!file) {
      return
    }

    onChangeImage({
      targetImage: file,
      targetKey: index
    })
  }
  return (
    <div styleName="fieldContainer">
      {showImage ? (
        <label styleName="imageButton">
          <ImageButton handleClick={onClickImage} imagePath={choiceImage} />
          {onChangeImage ? (
            <input hidden type="file" accept="image/png,image/jpg,image/bmp" onChange={handleChangeImage} />
          ) : null}
        </label>
      ) : null}
      <div styleName={showImage && showRadioButton ? 'textFieldGroup withImageAndRadio' : 'textFieldGroup'}>
        <input
          styleName="textField"
          type={type}
          maxLength={limitLength}
          value={text}
          placeholder={placeholder}
          onChange={e =>
            onChangeText({
              targetTitle: e.target.value,
              targetKey: index
            })
          }
        />
        <span styleName="highlight" />
        <span styleName="bar" />
        {showLimitCount ? (
          <p styleName="restTextLength">
            {text.length}
            <span styleName="denominator">/{limitLength}</span>
          </p>
        ) : null}
      </div>
      {showRadioButton ? (
        <div styleName="radioButton">
          <RadioButton
            value={Number(index)}
            selectedOption={answerChoiceId}
            handleChange={onChangeAnswerChoice}
            text={'正解'}
          />
        </div>
      ) : null}
    </div>
  )
}

EditorLimitTextField.propTypes = {
  index: PropTypes.number,
  limitLength: PropTypes.number,
  text: PropTypes.string.isRequired,
  answerChoiceId: PropTypes.number,
  onChangeText: PropTypes.func,
  showLimitCount: PropTypes.bool.isRequired,
  showImage: PropTypes.bool.isRequired,
  showRadioButton: PropTypes.bool.isRequired,
  choiceImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChangeImage: PropTypes.func,
  onChangeAnswerChoice: PropTypes.func,
  onClickImage: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  errorMessage: PropTypes.string
}

EditorLimitTextField.defaultProps = {
  text: '',
  showLimitCount: true,
  showImage: true,
  showRadioButton: true,
  placeholder: '',
  type: 'text'
}

export default compose(pure)(EditorLimitTextField)
